// src/Footer.js
import React from "react";

const Footer = () => {
  return (
    <footer className="bg-blue-8 text-white flex items-center w-full h-full flex-col pt-10 pb-4">
      <div className="max-w-screen-xl flex flex-col md:flex-row justify-between flex-wrap items-center md:items-start w-full mb-4">
        <div className="flex flex-col gap-8 md:w-[40%] w-full items-center md:items-start px-10 xl:px-0">
          <img
            src="/assets/images/logo/dark-logo.webp"
            alt="logo-dark"
            className="w-[312px]"
          />
          <p className="text-lg md:max-w-[312px] max-w-[80%] text-justify">
            We're excited to assist you in achieving a cleaner, healthier space.
            Contact us today and take the first step towards a spotless
            environment!
          </p>
        </div>
        <div className="flex flex-col gap-8 h-full md:w-[35%] w-[60%] mt-10 md:mt-0">
          <p className="text-lg">Contact</p>
          <a
            className="flex text-sm gap-3 items-center"
            href="tel:+61404509680"
          >
            <img
              src="/assets/images/footer/phone.png"
              alt="call"
              className="w-8"
            />
            <p className="text-sm">0404 509 680</p>
          </a>
          <a
            className="flex text-sm gap-3 items-center"
            href="mailto:info@clearchoicecs.com.au"
          >
            <img
              src="/assets/images/footer/email.png"
              alt="email"
              className="w-8"
            />
            <p className="text-sm">info@clearchoicecs.com.au</p>
          </a>

          <a
            className="flex text-sm gap-3 items-start"
            target="_blank"
            rel="noopener noreferrer"
            href="https://maps.app.goo.gl/KW3gRPpLz3k5pjgQ8"
          >
            <img
              src="/assets/images/footer/location.png"
              alt="email"
              className="w-8"
            />
            <p className="text-sm md:max-w-[38%]">
              70 Hughes Crescent, Dandenong North, 3175
            </p>
          </a>
        </div>
        <div className="flex flex-col gap-8 h-full md:w-[25%] w-full items-center md:items-start pt-10 md:pt-0">
          <p className="text-lg">Working Hours</p>
          <p className="text-sm">Mon - Sat &nbsp;&nbsp; 09.00 am - 05.00 pm</p>
        </div>
      </div>
      {/* <div className="max-w-screen-xl w-full flex items-center md:justify-end justify-center gap-5 mb-8 mt-5 md:mt-0 px-4 xl:px-0">
        <a
          href="http://google.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-sm md:text-tiny"
        >
          Terms & Conditions
        </a>

        <a
          href="http://google.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-sm md:text-tiny"
        >
          Privacy Policy
        </a>
      </div> */}

      <div className="max-w-screen-xl mx-auto text-center uppercase">
        <p className="md:text-xs text-[10px] px-2 md:px-0">
          COPYRIGHT &copy; CLEAR CHOICE CLEANING SERVICES |{" "}
          {new Date().getFullYear()} | MADE WITH ZECHRA PVT LTD
        </p>
      </div>
    </footer>
  );
};

export default Footer;
